import { Container } from '@mui/material'
import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import TableMui from 'src/components/TableMui'
import { actions } from 'src/features/basic-queries/BasicQueriesState'
import { CustomTextField } from 'src/features/basic-queries/components/BasicQuery.styles'
import { BasicQueriesHeader } from 'src/features/basic-queries/components/Header/Header'
import { ProductInfoCard } from 'src/features/basic-queries/components/ProductInfoCard/ProductInfoCard'
import { State } from 'src/features/types'
import { useSelector, useStore } from 'src/utils/store'

export const AddressDetail = () => {
  const { address, productCode } = useParams<{
    address: string,
    productCode: string
  }>()
  const store = useStore()
  const dispatch = useDispatch()
  const addressDetails = useSelector((state: State) => state.basicQuery.addressDetails)
  const addressInfoSelected = useSelector((state: State) => state.basicQuery.addressInfo?.productList.find((item) => item.product.codProduto === productCode))

  useEffect(() => {
    const { basicQuery: { addressInfo } } = store.getState()
    dispatch(actions.getAddressDetail({ address, product: productCode }))

    if (!addressInfo) dispatch(actions.getAddressInfo(address))

    return () => {
      dispatch(actions.setAddressDetail())
    }
  }, [address, dispatch, productCode, store])

  const resolveBatchesTableRows = useMemo(() => addressDetails?.map(({
    batch,
    stockBatchDue,
  }) => ({
    idBatch: batch.idLote,
    dueDate: batch.dataValidade,
    quantity: stockBatchDue.quantidade,
  })), [addressDetails])

  return (
    <Container>
      <BasicQueriesHeader title='Estoque Detalhado'/>
      <CustomTextField
        disabled
        value={address}
        name='address'
        label='address'
        testId='address'
        variant='outlined'
        autoFocus
        fullWidth
        InputLabelProps={{ shrink: true }}
      />

      {
        addressInfoSelected && (
        <ProductInfoCard
          description={addressInfoSelected.product.descProduto}
          idModel={addressInfoSelected.product.idModelo}
          productCode={addressInfoSelected.product.codProduto}
        />
        )
      }

      {
        resolveBatchesTableRows && (
          <TableMui
            flatTable
            enablePagination
            hasSorting
            rowsPerPageOptions={[10, 20, 30, 50, 100]}
            rowsPerPageLimit={30}
            columns={[
              { id: 'idBatch', label: 'Lote' },
              { id: 'quantity', label: 'Estoque' },
              {
                id: 'dueDate', label: 'Validade', isDate: true, dateFormat: 'DD/MM/YYYY',
              },
            ]}
            rows={resolveBatchesTableRows}
          />
        )
      }
    </Container>
  )
}
